<template>
  <v-app-bar
    app
    fixed
    height="54"
    tile
    style="border-bottom:1px solid #ddd;box-shadow:none; background-color:white"
    v-if="showHeader"
  >
    <div class="headerMenu">
      <v-app-bar-nav-icon
        :class="headerTitle ? 'headerBack' : 'visibleMenu'"
        @click='onClick()'
        color="#017BFF"
      >
        <img :src="require('@/assets/img/back.png')" width="12px" />
        <span class="backSpace" :style="styles">Back</span>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <div class="headerTitle" :style="styles">{{ headerTitle }}</div>
        <img
          style="margin-top: 5px"
          v-if="!headerTitle"
          :src="require('@/assets/img/CHIFamilyTitle.png')"
          height="38"
          width="155"
        />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon text v-show="headerTitle"
        ><v-icon color="transparent"
          >mdi-chevron-left</v-icon
        ></v-app-bar-nav-icon
      >
    </div>
  </v-app-bar>
</template>

<script>
import { convertEmToPixels } from '@/helper/helper'

export default {
  name: 'MainHeader',
  props: {
    showHeader: Boolean,
    headerTitle: String,
    onClick: Function
  },
  computed: {
    styles () {
      const result = convertEmToPixels(16)
      return {
        'font-size': result + 'px',
        'line-height': `${result + 2}px`
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header/index.vue